import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool
import { templateConfig, reduxTemplateCofig } from './config'
let { WizBrowserExport } = component_tool

class Satisfaction extends WizContainer {

    componentName = 'Satisfaction'

    constructor(props) {
        super(props)
        this.state = {}
    }

    _handleCMD(nextProps, nextState, key) {
        let o = nextProps[key]
        if (o['success']) {
            wizNotice.success(o['msg'])
            return true
        } else {
            wizNotice.error(o['msg'])
            return false
        }
    }

    _handleFile(nextProps, nextState, key) {
        let { code, data, msg } = nextProps[key]
        if (code === 1) {
            let columns = [{
                headerName: '',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
                }
            }, {
                headerName: '满意度参数',
                field: 'name',
                width: 30,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '辅导模块',
                field: 'moduleType',
                width: 30,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '值类型',
                field: 'valueType',
                width: 50,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '状态',
                field: 'state',
                width: 50,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }]

            let rows = data.map(item => {
                let { moduleType, valueType, state } = item
                item.moduleType = moduleType === 0 ? '销售' : '售后'
                item.state = state === 0 ? '禁用' : '启用'
                switch (valueType) {
                    case 0:
                        item.valueType = '正整数'
                        break
                    case 1:
                        item.valueType = '百分比'
                        break
                    case 2:
                        item.valueType = '文字'
                        break
                    case 3:
                        item.valueType = '百分比，x/y'
                        break
                    case 4:
                        item.valueType = '浮点数'
                        break
                    default:
                        item.valueType = ''
                }
                return item
            })

            WizBrowserExport({
                title: '满意度参数',
                sheetName: '满意度参数',
                columns: columns.filter((_, index) => index),
                rows,
                filename: '满意度参数.xlsx',
            })
            return true
        } else {
            wizNotice.error(msg)
            return false
        }
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig,
            apiDataFormat: {
                add: this._handleCMD,
                enable: this._handleCMD,
                export: this._handleFile
            },
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(Satisfaction)
